import { FC } from 'react';

interface EyeIconProps {
  className?: string;
  fill?: string;
}

export const EyeIcon: FC<EyeIconProps> = ({
  className,
  fill = 'currentColor',
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.25C7.16751 5.25 2.91626 8.4225 1.125 12.75C2.91626 17.0775 7.16751 20.25 12 20.25C16.8325 20.25 21.0837 17.0775 22.875 12.75C21.0837 8.4225 16.8325 5.25 12 5.25ZM12 18C9.1005 18 6.6255 16.2525 5.20875 13.5C6.6255 10.7475 9.1005 9 12 9C14.8995 9 17.3745 10.7475 18.7913 13.5C17.3745 16.2525 14.8995 18 12 18ZM12 10.5C10.3433 10.5 9 11.8433 9 13.5C9 15.1567 10.3433 16.5 12 16.5C13.6567 16.5 15 15.1567 15 13.5C15 11.8433 13.6567 10.5 12 10.5Z"
      fill={fill}
    />
  </svg>
);

export const EyeOffIcon: FC<EyeIconProps> = ({
  className,
  fill = 'currentColor',
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C20.67 15.34 21.52 13.68 22 11.83C20.27 7.5325 16.0525 4.36 11.22 4.36C9.94 4.36 8.72 4.63 7.62 5.11L9.78 7.27C10.35 7.04 11.06 6.91 11.8 6.91C12 6.91 12 7 12 7ZM2 4.27L3.28 5.55L4.74 7.01C3.08 8.3 1.78 10.02 1 11.83C2.73 16.1275 6.9475 19.3 11.78 19.3C13.06 19.3 14.28 19.03 15.38 18.55L16.84 20.01L18.12 21.29L19.73 19.68L3.41 3.36L2 4.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8ZM11.84 9.02L14.99 12.17L15.01 12.15C15.01 12.1 15 12.05 15 12C15 10.34 13.66 9 12 9C11.95 9 11.9 9.01 11.84 9.02Z"
      fill={fill}
    />
  </svg>
);
